import { Factory } from 'rosie';
import '../conversation_item_factory';

Factory.define('AIQualityCheckMessage')
  .attr('type', 'AI_QUALITY_CHECK');

Factory.define('AIQualityCheckMessageWithDefaults')
  .extend('AIQualityCheckMessage')
  .attr('guideId', 'default-guide-id')
  .attr('guideType', 'TRANSACTION_GUIDE')
  .attr('original', 'mock-message')
  .attr('rephrased', 'mock-message')
  .attr('causedByItems', [])
  .attr('qualityCheckResult', {
    passes: true,
    components: {
        Check: {
            passes: true,
            metadata: 
            {
                rationale: 'check-passed',
            }
        }

    }
  })
  .attr('originalBotMessage', 'original-bot-message');


Factory.define('AIQualityCheckMessageItemWithDefaults')
  .extend('ConversationItem')
  .attr('content', ['content'], content => Factory.attributes('AIQualityCheckMessageWithDefaults', content))
  .attr('initiator', {
    type: 'SYSTEM',
    id: 'SIDEKICK_V2',
  });
